var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 2.5,
    stroke: "#717C8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.45034C13.5 7.02291 13.2967 7.69298 12.931 8.42319C12.5679 9.14803 12.0624 9.89767 11.4996 10.62C10.3741 12.0646 9.05411 13.3567 8.29133 14.0638C8.12195 14.2208 7.87431 14.2208 7.705 14.0637C6.94265 13.3565 5.62358 12.0644 4.4989 10.6199C3.93658 9.89762 3.43138 9.14801 3.06861 8.4232C2.70315 7.69303 2.5 7.02295 2.5 6.45034C2.5 3.26732 5.00287 0.5 8 0.5C10.9971 0.5 13.5 3.26732 13.5 6.45034Z",
    stroke: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c3b5c4d0a68f011f9b9e516a66170fd7.svg";
export { ForwardRef as ReactComponent };